import "../../styles/twickenhamPageMob.scss"
import {useInView} from "react-intersection-observer";

export const FirstTwickenhamRoomMob = () => {

    const optionsForLowHeight = {
        threshold: 0.1,
        triggerOnce: true
    }

    const [ref1, inView1] = useInView(optionsForLowHeight)
    const [ref2, inView2] = useInView(optionsForLowHeight)

    return (
        <section className="first-tw-room-mob photo-section">
            <div className="first-tw-room-mob__wrapper">
                <div ref={ref1} className="first-tw-room-mob__top">
                    {inView1 &&
                        <img
                            className="opacity-animation-1_5s"
                            style={{width: "84vw", height: "112vw"}}
                            src="TwicknhamPage/TwickenhamFRoomLeftMob.jpg"
                            alt="#"
                        />
                    }
                </div>
                <div ref={ref2} className="first-tw-room-mob__bottom">
                    {inView2 &&
                        <img
                            className="first-tw-room-mob__bottom_img opacity-animation-1_5s"
                            style={{width: "40vw", height: "51.3vw"}}
                            src="TwicknhamPage/TwickenhamFRoomRightUpMob.jpg"
                            alt="#"
                        />
                    }

                    {inView2 && <div className="first-tw-room-mob__line line opacity-animation-2s"></div>}

                    {inView2 &&
                        <img
                            className="first-tw-room-mob__bottom_img opacity-animation-1_5s"
                            style={{width: "40vw", height: "51.3vw"}}
                            src="TwicknhamPage/TwickenhamFRoomRightDwnMob.jpg"
                            alt="#"
                        />}
                </div>
            </div>
        </section>
    )
}